<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>

                    <div class="content">
                        <div class="onlineTeachingCont">

                            <div class="onlineTeachingContRight">
                                <div class="onlineTeachingContPadding">
                                    <div class="onlineTeachingContTop">
                                        <div class="classTypesSelect">
                                            <el-select v-model="year_value" placeholder="请选择" @change="yearChange">
                                                <el-option v-for="item in year" :key="item" :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>

                                        <div class="classTypesTab">
                                            <p v-for="(item, idx) in classTypesTabData" :key="idx"
                                                :class="{'active':activeIdx === idx}" @click="classTypesTabEvent(idx)">
                                                {{item.title}}</p>
                                        </div>

                                        <!--网授课程模块-->
                                        <div class="onlineCourseAllCont" v-show="this.activeIdx == 0">

                                            <!--网授课选修必修列表-->
                                            <div v-show="isShowoOnlineCourseListFlag">

                                                <div class="compulsoryCourseCont">

                                                    <p class="compulsoryCourseTitle">必修课</p>
                                                    <ul class="compulsoryCourseList">
                                                        <li>
                                                            <div class="compulsoryCourseImg fl">
                                                                <img
                                                                    src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                            </div>
                                                            <div class="compulsoryCourseImgInfor  fl">
                                                                <p class="compulsoryCourseImgTitle textCut">
                                                                    必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                                </p>
                                                                <p class="compulsoryCourseScore">学分：1.0</p>
                                                            </div>

                                                            <div class="studenInterest">
                                                                <span class="trySeeBtn buttonBorderStyle">试看</span>
                                                                <span class="alreadyJoinBtn blueGradient">已加入</span>
                                                                <span class="joinLearnBtn">加入学习</span>
                                                            </div>

                                                        </li>
                                                        <li>
                                                            <div class="compulsoryCourseImg fl">
                                                                <img
                                                                    src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                            </div>
                                                            <div class="compulsoryCourseImgInfor  fl">
                                                                <p class="compulsoryCourseImgTitle textCut">
                                                                    必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                                </p>
                                                                <p class="compulsoryCourseScore">学分：1.0</p>
                                                            </div>

                                                        </li>

                                                    </ul>
                                                </div>

                                                <div class="electiveCoursesCont">
                                                    <p class="compulsoryCourseTitle">选修课</p>

                                                    <ul class="compulsoryCourseList">
                                                        <li>
                                                            <div class="compulsoryCourseImg fl">
                                                                <img
                                                                    src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                            </div>
                                                            <div class="compulsoryCourseImgInfor  fl">
                                                                <p class="compulsoryCourseImgTitle textCut">
                                                                    必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                                </p>
                                                                <p class="compulsoryCourseScore">学分：1.0</p>
                                                            </div>

                                                            <div class="studenInterest">
                                                                <span class="trySeeBtn buttonBorderStyle">试看</span>
                                                                <span class="alreadyJoinBtn blueGradient">已加入</span>
                                                                <span class="joinLearnBtn">加入学习</span>
                                                            </div>

                                                        </li>
                                                        <li>
                                                            <div class="compulsoryCourseImg fl">
                                                                <img
                                                                    src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                            </div>
                                                            <div class="compulsoryCourseImgInfor  fl">
                                                                <p class="compulsoryCourseImgTitle textCut">
                                                                    必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                                </p>
                                                                <p class="compulsoryCourseScore">学分：1.0</p>
                                                            </div>

                                                        </li>

                                                    </ul>

                                                </div>

                                                <div class="chooseResultCont">
                                                    <p>您当前已选择，课程：<span>3</span>门 学分：<span>3.0</span></p>
                                                </div>

                                                <div class="signUpNowBtn blueGradient" @click="onlineSignUpNowEvent()">
                                                    立即报名</div>
                                            </div>

                                            <!--网授课确认报名-->
                                            <div class="onlineConfirmSignUp"
                                                v-show="isShowConfirmOnlineCourseSignUpList">
                                                <div class="compulsoryCourseCont">
                                                    <p class="compulsoryCourseTitle confirmSignUpTitle"><span>学分：<font>
                                                                8.0</font></span> <span>课程：<font>8门</font></span></p>
                                                    <div class="faceCompulsoryCourseList">
                                                        <ul class="faceCourseAddressList  classScheduleList">
                                                            <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                                                                <span
                                                                    class="classScheduleTitle textCut">【必修】{{item.address}}</span>
                                                                <span
                                                                    class="classScheduleTeacher">学分：{{item.teacher}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="dividingLine"></div>

                                                    <div class="faceCompulsoryCourseList">
                                                        <ul class="faceCourseAddressList  classScheduleList">
                                                            <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                                                                <span
                                                                    class="classScheduleTitle textCut">【选修】{{item.address}}</span>
                                                                <span
                                                                    class="classScheduleTeacher">学分：{{item.teacher}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="onlineConfirmSignUpBtns">
                                                        <p class="blueGradient continueSelectOnlineCourse"
                                                            @click="continueOnlineSelectCourseEvent()">继续选课</p>
                                                        <p class="blueGradient confirmSignUpOnlineCourse"
                                                            @click="confirmSignUpOnlineCourseEvent()">确认报名</p>
                                                    </div>
                                                </div>

                                            </div>

                                            <!--网授课二次确认报名弹窗-->
                                            <div class="onlineCourseConfirmSignUpPop"
                                                v-if="isShowConfirmOnlineCourseSignUpPopFlag">
                                                <div class="coverLayer"></div>
                                                <div class="onlineCourseConfirmSignUpPopCont">
                                                    <p class="compulsoryCourseTitle confirmSignUpTitle">课程详情</p>
                                                    <div class="faceCompulsoryCourseList">
                                                        <ul class="faceCourseAddressList  classScheduleList">
                                                            <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                                                                <span
                                                                    class="classScheduleTitle textCut">【必修】{{item.address}}</span>
                                                                <span
                                                                    class="classScheduleTeacher">学分：{{item.teacher}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="dividingLine"></div>

                                                    <div class="faceCompulsoryCourseList">
                                                        <ul class="faceCourseAddressList  classScheduleList">
                                                            <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                                                                <span
                                                                    class="classScheduleTitle textCut">【选修】{{item.address}}</span>
                                                                <span
                                                                    class="classScheduleTeacher">学分：{{item.teacher}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="signUpNowBtn blueGradient">立即报名</div>
                                                    <ul class="icon-list closeBtn" @click="closeConfirmSignUpPop()">
                                                        <span><i class="el-icon-circle-close"></i></span>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                        <!--面授课程模块-->
                                        <div class="faceCourseAllCont" v-show="this.activeIdx == 1">
                                            <!--面授课上课地点-->
                                            <div class="compulsoryCourseCont" v-show="isShowFaceSelcetAddressFlag">
                                                <p class="compulsoryCourseTitle">请选择上课地点</p>
                                                <ul class="faceCourseAddressList">
                                                    <li v-for="(item, idx) in faceCourseAddress" :key="idx"
                                                        class="textCut" @click="jumpSelectClasses()">{{item.address}}
                                                    </li>
                                                </ul>
                                            </div>

                                            <!--面授课选择班次-->
                                            <div class="compulsoryCourseCont" v-show="isShowFaceSelectClassesFlag">
                                                <p class="compulsoryCourseTitle">请选择班次</p>
                                                <ul class="compulsoryCourseList selectClassesList">
                                                    <li>
                                                        <div class="compulsoryCourseImgInfor">
                                                            <p class="compulsoryCourseImgTitle textCut">第一期</p>
                                                            <p class="compulsoryCourseScore">开课时间：2020-05-26 13:00 </p>
                                                            <p class="compulsoryCourseScore">授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                                                        </div>

                                                        <div class="studenInterest">
                                                            <span class="blueGradient">立即报名</span>
                                                            <span class="alreadyJoinBtn blueGradient"
                                                                @click="seeFaceCourseDetail()">查看详情</span>
                                                        </div>
                                                        <div class="signUpStatus">
                                                            已报名<span>123</span>/总数<span>150</span>
                                                        </div>

                                                    </li>
                                                    <li>
                                                        <div class="compulsoryCourseImgInfor">
                                                            <p class="compulsoryCourseImgTitle textCut">第一期</p>
                                                            <p class="compulsoryCourseScore">开课时间：2020-05-26 13:00 </p>
                                                            <p class="compulsoryCourseScore">授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                                                        </div>

                                                        <div class="studenInterest">
                                                            <span class="blueGradient">立即报名</span>
                                                            <span class="alreadyJoinBtn blueGradient"
                                                                @click="seeFaceCourseDetail()">查看详情</span>
                                                        </div>
                                                        <div class="signUpStatus">
                                                            已报名<span>123</span>/总数<span>150</span>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div>

                                            <!--面授课课程详情-->
                                            <div class="compulsoryCourseCont"
                                                v-show="isShowFaceSelectClassesDetailFlag">
                                                <div>
                                                    <p class="compulsoryCourseTitle">课程详情</p>
                                                    <div class="faceCourseDetail">
                                                        <p>授课时间：2020-05-26 13:00至2020-05-26 17:00</p>
                                                        <p>报名截止时间：2020-05-26 12:00</p>
                                                        <p>授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                                                        <p>公交路线：908/908区间/909（湖南中药大学站下车）</p>
                                                        <p style="color:red;">此处有查看地图功能，待完善</p>
                                                    </div>
                                                </div>

                                                <div class="compulsoryCourseCont">
                                                    <p class="compulsoryCourseTitle">课程表</p>
                                                    <ul class="faceCourseAddressList  classScheduleList">
                                                        <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                                                            <span
                                                                class="classScheduleTitle textCut">{{item.address}}</span>
                                                            <span
                                                                class="classScheduleTeacher">老师：{{item.teacher}}</span>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="signUpNowBtn blueGradient">立即报名</div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </section>
            </el-main>
        </el-container>
    </el-container>

</template>


<script>
import commonheader from '../common/commonHeader.vue' //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件

export default {
    name: "index",
    components: {
        commonheader,
        leftMenu,
        exit
    },
    data () {
        return {
            year: [],
            year_value: '',

            classTypesTabData: [
                {
                    'title': '网授课程'
                },
                {
                    'title': '面授课程'
                }
            ],
            activeIdx: 0,
            faceCourseAddress: [
                {
                    'address': '湖南中医药湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '张张老师'
                },
                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                }
            ],
            isShowFaceSelcetAddressFlag: true,
            isShowFaceSelectClassesFlag: false,
            isShowFaceSelectClassesDetailFlag: false,

            isShowoOnlineCourseListFlag: true,
            isShowConfirmOnlineCourseSignUpList: false,
            isShowConfirmOnlineCourseSignUpPopFlag: false,

        };
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        
        this.getYear();
    },
    
    methods: {
        /**
         * 获取年份
         */
        getYear(){
            this.$store.dispatch('academic_year',{}).then((res) => {
                this.year = res.data;
                this.year_value = res.data[0];
                this.getMyCourse();
            })
        },
        /**
         * 获取我的课程
         * year  年份
         * type  教育类型： 1 网授 2 面授
         */
        getMyCourse (year,type){
            let params = {
                year:this.year_value,
                type:this.activeIdx+1
            }
            this.$store.dispatch('mycourses',params).then((res) => {
                // this.year = res.data;
                console.log()
            })
        },
        /**
         * 年份改变
         */
        yearChange(){
            this.getMyCourse();
        },

        classTypesTabEvent (idx) {
            this.activeIdx = idx

            if (idx == 0) {
                this.isShowoOnlineCourseListFlag = true;
                this.isShowConfirmOnlineCourseSignUpList = false;
                this.isShowConfirmOnlineCourseSignUpPopFlag = false;
            }
            if (idx == 1) {
                this.isShowFaceSelcetAddressFlag = true;
                this.isShowFaceSelectClassesFlag = false;
                this.isShowFaceSelectClassesDetailFlag = false;
            }
        },

        jumpSelectClasses () {
            this.isShowFaceSelcetAddressFlag = false;
            this.isShowFaceSelectClassesDetailFlag = false;
            this.isShowFaceSelectClassesFlag = true;
        },
        seeFaceCourseDetail () {
            this.isShowFaceSelcetAddressFlag = false;
            this.isShowFaceSelectClassesFlag = false;
            this.isShowFaceSelectClassesDetailFlag = true;
        },

        closeConfirmSignUpPop () {
            this.isShowConfirmOnlineCourseSignUpPopFlag = false;
        },

        onlineSignUpNowEvent () {
            this.isShowoOnlineCourseListFlag = false;
            this.isShowConfirmOnlineCourseSignUpList = true;
            this.isShowConfirmOnlineCourseSignUpPopFlag = false;

        },

        continueOnlineSelectCourseEvent () {
            this.isShowoOnlineCourseListFlag = true;
            this.isShowConfirmOnlineCourseSignUpList = false;
            this.isShowConfirmOnlineCourseSignUpPopFlag = false;

        },

        confirmSignUpOnlineCourseEvent () {
            this.isShowoOnlineCourseListFlag = false;
            this.isShowConfirmOnlineCourseSignUpList = true;
            this.isShowConfirmOnlineCourseSignUpPopFlag = true;
        },



    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1400px;
        margin: auto;
    }
}

.el-aside {
    background: #fff;
}

.el-main {
    padding: 0;
    background: #fff;
}

.content {
    padding: 47px 57px 0 86px;
    flex: 1;
    border-top: 10px solid #f8f8f8;
    border-left: 10px solid #f8f8f8;
}

/* .content {
  width:1400px;
  margin: 0 auto;
  padding-bottom:40px;
} */

.onlineTeachingContRight {
    background: #fff;
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5);
  position:relative;
  left:-2px; */
}

.onlineTeachingCont {
    /* overflow: hidden; */
    padding-bottom: 50px;
}

.onlineTeachingContPadding {
    /* padding:50px; */
    background: #fff;
    border-radius: 4px;
}

.classTypesTab,
.onlineConfirmSignUpBtns {
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
}
.classTypesTab > p {
    display: inline-block;
    margin: 0 35px;
    width: 110px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #0173ff;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}

.onlineConfirmSignUpBtns {
    margin-top: 100px;
}
.onlineConfirmSignUpBtns > p {
    display: inline-block;
    margin: 0 35px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}

.classTypesTab > p.active {
    background-image: -webkit-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -o-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -ms-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: linear-gradient(left, #4bb7fc, #0173ff);
    color: #fff;
    border: none;
}

.onlineTeachingContTop {
    position: relative;
}

.classTypesSelect {
    position: absolute;
    left: 0px;
    top: 0;
}

.compulsoryCourseCont {
    margin-top: 50px;
}

.compulsoryCourseTitle {
    font-size: 18px;
    color: #333;
    padding-left: 10px;
    border-left: 4px solid #0173ff;
    font-weight: bold;
}

.compulsoryCourseList {
    margin: 0 5px 0 10px;
}
.compulsoryCourseList li {
    padding: 10px;
    overflow: hidden;
    border-radius: 8px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(218, 218, 218, 0.5);
    position: relative;
}
.compulsoryCourseImg img {
    width: 105px;
    height: 80px;
    display: block;
}

.compulsoryCourseImgInfor {
    max-width: 55%;
    margin-left: 15px;
}

.compulsoryCourseImgTitle {
    width: 100%;
    color: #333;
    font-weight: bold;
}
.compulsoryCourseImgTitle,
.compulsoryCourseScore {
    margin-top: 12px;
}
.compulsoryCourseScore {
    color: #666;
    font-size: 14px;
}

.studenInterest {
    position: absolute;
    right: 10px;
    bottom: 20px;
    font-size: 14px;
}

.studenInterest span {
    display: inline-block;
    width: 72px;
    height: 26px;
    line-height: 26px;
    /* color:#0173FF; */
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 20px;
}

.studenInterest span.trySeeBtn,
.studenInterest span.alreadyJoinBtn {
    /* color:#fff; */
    /* background-image:-webkit-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:-o-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:-ms-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:linear-gradient(left,#4BB7FC,rgb(31, 132, 255)); */
}

.studenInterest span.joinLearnBtn {
    background: #fff;
    color: rgb(31, 132, 255);
    border: 1px solid rgb(31, 132, 255);
}

.electiveCoursesCont {
    margin-top: 50px;
}

.chooseResultCont {
    background: rgba(228, 240, 253, 1);
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    font-size: 14px;
    margin-top: 30px;
    width: 1170px;
    position: relative;
    left: -86px;
}

.signUpNowBtn {
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    width: 290px;
    margin: 50px auto 0;
    border-radius: 4px;
    cursor: pointer;
    letter-spacing: 2px;
}

.faceCourseAddressList {
    margin: 20px 0 0 10px;
}

.faceCourseAddressList li {
    height: 50px;
    line-height: 50px;
    color: #666;
    font-size: 16px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    padding: 0 5px;
    cursor: pointer;
}

.blueGradient {
    background-image: -webkit-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: -o-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: -ms-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    color: #fff;
}

.buttonBorderStyle {
    color: #0173ff;
    border: 1px solid #0173ff;
}

.selectClassesList .compulsoryCourseImgInfor {
    position: relative;
    top: -6px;
}

.signUpStatus {
    position: absolute;
    top: 25px;
    color: #999;
    font-size: 12px;
    right: 35px;
}

.selectClassesList {
    margin-top: 40px;
}

.faceCourseDetail {
    margin: 30px 30px 0 15px;
}
.faceCourseDetail > p {
    color: #333;
    line-height: 24px;
    margin-top: 10px;
    font-size: 14px;
}

.classScheduleTitle {
    width: 78%;
    float: left;
}

.classScheduleTeacher {
    float: left;
    margin-left: 50px;
}

.confirmSignUpTitle span {
    margin-right: 50px;
}
.confirmSignUpTitle span font {
    color: #0475ff;
}

.faceCompulsoryCourseList {
}
.dividingLine {
    height: 12px;
    background: rgba(248, 248, 248, 1);
}

.onlineCourseConfirmSignUpPop {
}

.coverLayer {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
}

.onlineCourseConfirmSignUpPopCont {
    position: fixed;
    width: 1050px;
    padding: 50px 35px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 4px;
}

.closeBtn {
    position: absolute;

    right: 12px;
    top: 5px;
    font-size: 32px;
    cursor: pointer;
}
.closeBtn:hover {
    color: #0475ff;
}
</style>


// WEBPACK FOOTER //
// src/components/my/onlineTeaching.vue